import { queryOptions, useQuery } from '@tanstack/react-query';

import { pagesApi } from '../api/pages-api';

import { pageKeys } from './page-keys';

export function pageQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: pageKeys.detail(storeId, id),
    queryFn: () => pagesApi.get(storeId, id),
  });
}

export function usePage(storeId: string, id: string) {
  return useQuery(pageQueryOptions(storeId, id));
}
